import { CKSkeleton } from 'clearkit';

import { ImplementationCard } from '../ImplementationCard';

export const LoadingCard = () => (
  <ImplementationCard progress={0}>
    <ImplementationCard.Heading>
      <CKSkeleton className="h-[1.25rem] w-[20ch]" isLoading />
    </ImplementationCard.Heading>
    <ImplementationCard.Description>
      <CKSkeleton className="w-full h-[6rem]" isLoading />
    </ImplementationCard.Description>
    <ImplementationCard.Footer>
      <CKSkeleton className="h-[2.25rem] w-[9rem]" isLoading />
      <CKSkeleton className="h-[1.25rem] w-[4rem]" isLoading />
    </ImplementationCard.Footer>
  </ImplementationCard>
);
